<template>
<div>
    <div
        id="heat-exchanger"
        class="wrapper"
    >
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 熱交換 -->
        <app-error-list/>
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="熱交換">1</parts-arrow>
                <span>熱交換型換気設備の設置の有無を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="熱交換型換気設備"
                class="flex_column"
                name="hv_houshiki"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2', '1']"
                    v-model="hv_houshiki"
                    :value="value"
                    unit=""
                    :key="'hv_houshiki' + value"
                >
                    {{master.hv_houshiki[value]}}
                </app-radio>
                <information-box
                    title="熱交換型換気設備を設置する場合"
                >
                    <p>換気設備の方式に「ダクト式第一種換気設備」または「壁付け式第一種換気設備」を選択します。</p>
                </information-box>
            </app-box>
        </app-section>
        <app-section v-if="hv_houshiki == '1'">
            <h3 slot="h3">
                <parts-arrow category="熱交換">2</parts-arrow>
                <span>熱交換型換気設備の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="温度交換効率"
                class="flex_column"
                name="hv_eff"
                @click="guideTransition"
            >
                <app-text
                    label=""
                    unit="%"
                    v-model="hv_eff"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
            </app-box>
            <app-box
                v-if="hv_houshiki == '1'"
                :available="true"
                label="温度交換効率の補正係数の入力"
                class="flex_column uq_subbox_18em"
                @click="guideTransition"
                name="hv_correction_input"
            >
                <app-radio
                    v-for="(name, value) in master.hv_correction_input"
                    v-model="hv_correction_input"
                    :value="value"
                    unit=""
                    :key="'hv_correction_input' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <div v-if="hv_correction_input=='2'">
                <app-box
                    :available="true"
                    label="給気と排気の比率による温度交換効率の補正係数"
                    class="flex_column"
                    name="hv_bal"
                    @click="guideTransition"
                >
                    <app-text
                        label=""
                        unit=""
                        v-model="hv_bal"
                        class=""
                        subscript="(小数点以下2桁)"
                        :step="0.01"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="排気過多時における住宅外皮経由の漏気による温度交換効率の補正係数"
                    class="flex_column no_border"
                    name="hv_leak"
                    @click="guideTransition"
                >
                    <app-text
                        label=""
                        unit=""
                        v-model="hv_leak"
                        class=""
                        subscript="(小数点以下2桁)"
                        :step="0.01"
                    />
                </app-box>
                <information-box
                    title="補正係数の計算について"
                >
                    <p>補正係数は、<a href="https://house.lowenergy.jp/dictionary/heat-exchange#hv_bal" target="guide" class="target_blank">こちら</a>を参考に入力するか、<a href="https://cchexrate.app.lowenergy.jp/" target="_blank" class="target_blank">温度交換効率の補正係数（C<sub>bal</sub>, C<sub>leak</sub>）の算出ツール</a>により計算した値を入力します。</p>
                </information-box>
            </div>
        </app-section>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版熱交換情報入力画面
 * 
 * [算出プロパティ]
 * 詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'
import AppRadio from '../components/atoms/AppRadio.vue'

export default {
  components: { AppRadio },
    data: () => ({
        //test
        hogeHoge: "0",
    }),
    name:"PageHeatExchange",
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'hv_houshiki',
            'hv_eff',
            'hv_correction_input',
            'hv_bal',
            'hv_leak'
        ]),
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

<style scoped>
p:first-child{
    display: block;
    width: 90%;
    margin: 80px auto 16px;
}
.no_border{
    border-bottom:none;
}
.margin{
    margin:1em;
}
.wrapper >>> .section_wrap>.information .text p {
    display: inline-block;
    width: auto;
    margin-right: 0;
}
.wrapper >>> .information p{
    width: auto;
}
.wrapper >>> .information{
    margin-bottom: 8px;
}
</style>

